import * as Yup from 'yup';

const PHONE_NUMBER_REGEX = /^\+[1-9]\d{6,14}$/;
const phoneNumberMessage =
  'Le numéro doit respecter un format valide (ex: +33612345678)';

export const ContactInfoSchema = Yup.object().shape({
  email: Yup.string().email().optional(),
  mobileNumber: Yup.string()
    .matches(PHONE_NUMBER_REGEX, phoneNumberMessage)
    .optional(),
  landlineNumber: Yup.string()
    .matches(PHONE_NUMBER_REGEX, phoneNumberMessage)
    .optional(),
  professionalNumber: Yup.string()
    .matches(PHONE_NUMBER_REGEX, phoneNumberMessage)
    .optional(),
  faxNumber: Yup.string()
    .matches(PHONE_NUMBER_REGEX, phoneNumberMessage)
    .optional(),
  website: Yup.string().url().optional(),
});
